<template>
    <dialog ref="dialog" :style="style" class="v-tooldown" :class="tooldownclass" @keypress.esc="$emit('cancel')" tabindex="0" open><!--v-focus-->
        <div class="v-tooldown__content">
            <div class="margin-bottom-medium">
                <strong class="st-headline st-headline--2"><slot name="title">Titel</slot></strong>
                <slot name="message">Hier könnte Ihre Meldung stehen!</slot>
            </div>
            <div v-if="options">
                <div v-if="yesno">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 text-right">
                            <button @click.prevent.stop="$emit('cancel')" class="st-btn st-btn--small st-btn--cancel"><slot name="negative">{{ $t('Cancel') }}</slot></button>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <button @click.prevent.stop="$emit('ok')" class="st-btn st-btn--small" :class="positiveBtnClass"><slot name="positive">{{ $t('Confirm') }}</slot></button>
                        </div>
                    </div>
                </div>
                <div v-if="!yesno">
                    <div class="text-right">
                        <a @click.prevent.stop="$emit('cancel')" class="st-btn st-btn--small st-btn--close"><slot name="negative">{{ $t('Close') }}</slot></a>
                    </div>
                </div>
            </div>
        </div>
    </dialog>
</template>

<script>
export default {
  	name: 'v-tooldown',
  	data(){
  		return {
  			x:0,
  			y:0,
  			tooldownclass: '',
  			escEvent: false,
			saveEvent: false,
  		}
  	},
	props: {
		el: {
			default: function(){
				return document.createElement('div');
			}
		},
		type: {
		  type: String,
		  default: 'submit'
		},
		options: {
		  type: Boolean,
		  default: true
		},
		yesno: {
		  type: Boolean,
		  default: false
		},
		loading: {
		  type: Boolean,
		  default: false
		}
	},
	computed: {
		positiveBtnClass(){
			const classname = 'st-btn--' + this.type;

			return [
				classname,
				{
					'st-btn--loading': this.loading
				}
			];
		},
		style(){
			return 'top: ' + this.y +'px; left: '+ this.x +'px;';

			/*
			if (!this.el || typeof this.el.getBoundingClientRect !== 'function') {
				return '';
			}

			const rect = this.el.getBoundingClientRect(),
				  top 	= (Math.round(rect.top) + Math.round(rect.height) + 20),
				  left 	= (( rect.left + (rect.width / 2) ) - 14);

			return 'top: ' + top +'px; left: '+ left +'px;';
			*/
		}
	},
	mounted(){
		const mouseposition = this.$store.getters.mouseposition;
		if(this.el && (this.el.classList.contains('st-table-action__link') || this.el.classList.contains('st-link'))){
			var bodyRect = document.documentElement.getBoundingClientRect(),
				$elemRect = this.$el.getBoundingClientRect(),
    			elemRect = this.el.getBoundingClientRect();

			this.y = (elemRect.top - (bodyRect.top < 0 ? 15 : bodyRect.top + 10)) + ((elemRect.height));
			this.x = (elemRect.left - bodyRect.left) + ((elemRect.width/2) - 10);

		} else {
			this.y = mouseposition.y+25;
			this.x = mouseposition.x-7;
		}


		this.setTooldownCSSClasses()


		// this.escEvent = evn.subscribe('esc', this.$emit('cancel'));
		// this.saveEvent = evn.subscribe('save', this.$emit('ok'));
	},
	destroyed(){
		// if(this.escEvent) this.escEvent.remove();
		// if(this.saveEvent) this.saveEvent.remove();
	},
	methods:{
		setTooldownCSSClasses() {
			this.tooldownclass = '';
			if(!this.$el) return


			const rect = this.$el.getBoundingClientRect(),
				  left 	= (( rect.left + (rect.width / 2) ) - 14);

			let right = true,
				bottom = true;

			if((this.x + rect.width + 50) > window.innerWidth){
				right = false;
			}

			if((this.y + rect.height + 50) > window.innerHeight){
				bottom = false;
			}

			if (!right && !bottom) {

				this.tooldownclass = ' v-tooldown--left-top';
			} else if (!right && bottom) {

				this.tooldownclass = ' v-tooldown--left-bottom';
			} else if (right && !bottom) {

				this.tooldownclass = ' v-tooldown--right-top';
			} else if (right && bottom) {

				this.tooldownclass = ' v-tooldown--right-bottom';
			}
		}
	}
}
</script>

<style lang="scss">

.v-tooldown {
	min-width: 500px;

	border:0;
	position: fixed;
	background-color: #fff;
	color: #000;
	margin: 0;
	max-width: 39vw;
	right: auto;
	box-shadow: 0px 0px 3px 0 rgba(0, 0, 0, 0.4);
	z-index: 100;
	padding: 1em;
	display: block;
	background: white;
	&:after {
		content: "";
		width: 0;
		height: 0;

		border: 5px solid #fff;
		position: absolute;
	}

	&--left-bottom {
		transform: translateX(-100%);
		&:after {
		    top: -5px;
		    right: 3px;
		    transform: rotate(-45deg);
		    box-shadow: 2px -2px 3px 0 rgba(0, 0, 0, 0.2);
		}
	}
	&--left-top {
		transform: translateX(-100%) translateY(-105%);
		&:after {
		    bottom: -5px;
		    right: 3px;
		    transform: rotate(-45deg);
		    box-shadow: -2px 2px 3px 0 rgba(0, 0, 0, 0.2);
		}
	}
	&--right-top {
		transform: translateY(-105%);
		&:after {
		    bottom: -5px;
		    left: 3px;
		    transform: rotate(-45deg);
		    box-shadow: -2px 2px 3px 0 rgba(0, 0, 0, 0.2);
		}
	}
	&--right-bottom {
		&:after {
		    top: -5px;
		    left: 3px;
		    transform: rotate(-45deg);
		    box-shadow: 2px -2px 3px 0 rgba(0, 0, 0, 0.2);
		}
	}
	/*
	&--left-center {
		transform: translateX(-50%);
		&:after {
			left: 50%;
			transform: translateX(-50%) rotate(-45deg);
		}
	}
	*/
}
</style>



// WEBPACK FOOTER //
// src/components/v-tooldown.vue